var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ConnectionStatus'),_c('NetworkMetrics'),_c('transition',{attrs:{"name":_vm.routeAnimationName,"mode":_vm.routeAnimationMode},on:{"after-enter":function($event){return _vm.$store.commit('RouteAnimation/resetAnimations')}}},[_c('router-view',{staticClass:"router"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }